import React, {createRef} from "react";
import {useQueryClient} from "react-query";
import {makeStyles} from "@material-ui/core/styles";
import moment from "moment";
import __ from "lodash";
import {Card, Grid, CardContent, IconButton, Icon} from "@material-ui/core";
import { Flight, FlightLand, FlightTakeoff } from "@material-ui/icons";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"

import FlightStatus from "./FlightRampStatus";
import AircraftStatus from "../../Aircraft/components/AircraftStatus";
import useRampFlights from "../../../services/rampActions/useRampFlights";

const aogColor = "#9A0303";
const maintenanceColor = "#815B2C";
const flyingColor = "#494949";

const useStyles = makeStyles((theme) => ({
  icon: {
    fontSize: 36,
    '@media (max-width: 1700px), (max-height: 1040px)' : {
      fontSize: 24,
    },
    '@media (max-width: 1400px)' : {
      fontSize: 20,
    },
  },
  iconText: {
    fontSize: 18,
    '@media (max-width: 1700px), ' : {
      fontSize: 16,
    },
    '@media (max-width: 1400px), (max-height: 1040px)' : {
      fontSize: 14,
    },
  },
  card: {
    padding: 6,
    minWidth: "90%",
    maxWidth: "90%",
    borderRadius: 12,
    position: 'relative',
    backgroundColor: flyingColor,
    margin: 2
  },
  aogCard: {
    padding: 6,
    minWidth: "90%",
    maxWidth: "90%",
    borderRadius: 12,
    position: 'relative',
    backgroundColor: aogColor,
    margin: 10
  },
  scheduledCard: {
    padding: 6,
    minWidth: "90%",
    maxWidth: "90%",
    borderRadius: 12,
    position: 'relative',
    backgroundColor: maintenanceColor,
    margin: 10
  },
  cardContent: {
    borderRadius: 6,
    padding: "2px 2px 2px 2px",
    backgroundColor: '#f8f8fa',
  },
  cardTitle: {
    fontSize:24,
    '@media (max-width: 1600px)' : {
      fontSize: 20,
    },
    '@media (max-width: 1500px), (max-height: 1080px)' : {
      fontSize: 18,
    },
    '@media (max-width: 1400px)' : {
      fontSize: 15,
    },
    fontWeight:800,
    fontFamily:"Ubuntu, sans-serif",
    fontVariantCaps: "small-caps",
    width: "100%",
    alignContent: "center",
    verticalAlign: "middle",
    marginTop: 10,
    marginLeft: 0
  },
}));


const ActiveRampFlights = (props) => {
  const classes = useStyles();

  const tableRef = createRef({state: {lastEditingRow: false}});
  const queryClient = useQueryClient();
  const extraKeys = [];
  const flights = useRampFlights({tableRef, queryClient, extraKeys});

  const renderRampFlights = (flights) => {
    return (
      flights.map((flight, i) => {
        const flightDate = moment.utc(flight.scheduledTime).format("MMM/DD HH:mm").toUpperCase();
        return (
          <Grid item xs={"auto"} xl={"auto"} key={flight.flightNumber + flightDate}>
            <Card className={classes.card} key={i}>
              <CardContent className={classes.cardContent}>
                <div style={{display: "flex"}}>
                  <IconButton aria-label={flight.flightNumber} color="primary" style={{padding: "2px 2px"}} className={classes.icon}>
                    <div>
                      { flight.recordType === 'INBOUND' ? <FlightLand className={classes.icon} style={{ xfontSize: 36 }}/> : <FlightTakeoff className={classes.icon} style={{ xfontSize: 36 }}/> }
                      <div className={classes.iconText}>{ flight.flightNumber }</div>
                    </div>
                  </IconButton>
                  <div className={classes.cardTitle } style={{ color: flyingColor }}>
                    <div>
                      {`${flight.originAirportCode}-${flight.destinationAirportCode}`}<br/>
                      {`${flightDate + 'Z'}`}{`${flight.timeIsEstimated ? " (E)" : ""}`}
                    </div>
                  </div>
                </div>
              </CardContent>
              <FlightStatus
                direction={flight.recordType}
                airportCode={flight.airport}
                flightNumber={flight.flightNumber}
                aircraft={flight.aircraftTailNumber}
                scheduledTime={flight.scheduledTime}
              />
            </Card>
          </Grid>
        )
      })
    )
  }

  if (flights && flights.data) {
    return (
      <div style={{width:"calc(100% - 0px)", minWidth:"calc(100% - 0px)", overflowY: "scroll"}}>
        <ResponsiveMasonry columnsCountBreakPoints={{400: 1, 800: 2, 1200: 5, 1600: 6, 2000: 7, 2400: 8}}>
          <Masonry >
          {
            flights.data.map((flight, i) => {
              const flightDate = moment.utc(flight.scheduledTime).format("MMM/DD HH:mm").toUpperCase();
              return (
                <Masonry columnsCount={1}>
                  <Grid item xs={"auto"} xl={"auto"} key={flight.flightNumber + flightDate}>
                    <Card className={flight.activeMaintenance ? classes.aogCard : flight.scheduledMaintenance ? classes.scheduledCard : classes.card} key={i}>
                      <CardContent className={classes.cardContent}>
                        <div style={{display: "flex"}}>
                          <IconButton aria-label={flight.flightNumber} color="primary" style={{padding: "2px 2px"}} className={classes.icon}>
                            <div>
                              <Flight  className={classes.icon} style={{ fontSize: 24 }}/>
                              <div className={classes.iconText}>{flight.aircraftTailNumber}</div>
                            </div>
                          </IconButton>
                          <div className={classes.cardTitle } style={{ color: flyingColor }}>
                            <div>
                              {flight.flightNumber}<br/> {`${flightDate + 'Z'}`}
                            </div>
                          </div>
                        </div>
                      </CardContent>
                        <AircraftStatus
                          aircraftTailNumber={flight.aircraftTailNumber}
                          displayLastMovement
                          displayLastMovementOnSingleLine
                          marginLeft={10}
                          marginRight={10}
                          fontSize={18}
                          avatarSize={"small"}
                        />
                    </Card>
                  </Grid>
                  { __.has(flight, "rampFlights") ? renderRampFlights(flight.rampFlights): <></> }
                </Masonry>
              )
            })
          }
          </Masonry>
        </ResponsiveMasonry>
      </div>
    )
  }
  else
    return (<></>)
}

export default ActiveRampFlights;
